import * as React from 'react';
import {useState} from 'react';
import {Form} from "@intelingu/core/components/form/Form";
import {CardObject, useGetExerciseCardByIdQuery, useUpdateCardMutation} from "../../../../types.d";
import {getParam} from "../../../../utils/getParam";
import {Field} from "@intelingu/core/components/form/Field";
import {FormGroup} from "../../../partials/form/elements/FormGroup";
import {WordMasks, WordMasksController} from "../../../partials/WordMasks";
import {container} from "@intelingu/core/IoC/container";
import {WorkspaceStore} from "../../../../stores/WorkspaceStore";
import {TinyMCE} from "../../../partials/form/elements/TinyMCE";
import {useAppendToMce} from "./CreateVocabulary";
import {QuotaCheckField} from "../../../partials/QuotaCheckField";
import {Redirect} from "react-router";
import {SubmitButton} from "../../../partials/form/elements/SubmitButton";
import {AnswersField} from "../../../partials/form/elements/AnswersField";
import {IsNotEmpty, Validate} from "class-validator";
import {MceValidator} from "../../../../utils/mceValidator";
import {ExerciseTopic} from "../../../partials/ExerciseTopic";
import {FormErrorMessage} from "../../../partials/form/FormErrorMessage";

export class Validator {

    @Validate(MceValidator)
    explanationRules;

    @Validate(MceValidator)
    exerciseTranslation;

    @IsNotEmpty()
    infinitivesOnly;

    @IsNotEmpty()
    falseAnswers;

}

export const CreateExerciseForm = props => {
    const [created, setCreated] = useState<boolean>(false);
    const [masksController, setMasksController] = useState<WordMasksController>();
    const [editorRef, setEditorRef] = useState<any>();

    const courseId = container.get(WorkspaceStore).courseId;

    const [ updateCard, { data: updatedCard } ] = useUpdateCardMutation({
        fetchPolicy: 'no-cache'
    });

    const appendToMce = useAppendToMce(editorRef);

    const {
        data
    } = useGetExerciseCardByIdQuery({
        variables: { id: getParam<number>('card_id') }
    });

    if (!data || !data.card) {
        return <h2>Loading...</h2>
    }

    const { card } = data;

    if (created) {
        return <Redirect to={`/creation/next/${courseId}/LP`} />
    }

    return <Form
        validator={Validator}
        defaultData={{
            infinitivesOnly: card.infinitivesOnly,
            explanationRules: card.explanationRules,
            exerciseTranslation: card.exerciseTranslation,
            falseAnswers: card.falseAnswers,
        }}
        onSubmit={async (data, done) => {
            const value = JSON.parse(JSON.stringify(data));

            delete value.quotaExplanation1Valid;
            delete value.counterQuotaExplanation1Valid;

            await updateCard({
                variables: {
                    id: getParam<number>('card_id'),
                    input: value
                }
            });

            done();

            setCreated(true);
        }}
    >
        <ExerciseTopic card={card as CardObject} />

        <FormGroup
            className={'mt-5'}
            label={'Exercise'}
            required={true}
        >
            <WordMasks
                onReady={setMasksController}
                courseId={courseId}
                onSelect={appendToMce}
                rank={card.previouslyCreatedVocabulary.wordTranslation.sourceWord.rank} />

            <Field
                name={'explanationRules'}
                render={props => (
                    <TinyMCE
                        toolbar={''}
                        editor={setEditorRef}
                        {...props} />
                )} />
        </FormGroup>

        <FormGroup
            className={'mt-5'}
            label={'False answers'}
            required={true}
        >
            <Field
                name={'falseAnswers'}
                render={props => (
                    <AnswersField
                        {...props} />
                )} />
        </FormGroup>

        <FormGroup label={'Infinitives Only'} required={true}>
            <Field name={'infinitivesOnly'} render={props => (
                <QuotaCheckField
                    includedWords={[]}
                    sourceLanguage={card.course.sourceLanguage.id}
                    translationLanguage={card.course.translationLanguage.id}
                    explanationQuotaFieldName={'quotaExplanation1'}
                    explanationCounterFieldName={'counterQuotaExplanation1'}
                    wordMasksController={masksController}
                    getInfinitives={() => editorRef.editor.getContent({format: 'text'})}
                    {...props} />
            )} />
        </FormGroup>

        <FormGroup
            className={'mt-5'}
            label={'Translation of Exercise (including correct answer)'}
            required={true}
        >
            <Field
                name={'exerciseTranslation'}
                render={props => (
                    <TinyMCE
                        toolbar={''}
                        {...props} />
                )} />
        </FormGroup>

        <div className={'col-12'}>
            <FormErrorMessage />
            <Field submit render={props => <SubmitButton {...props}>Done</SubmitButton>} />
        </div>
    </Form>
};

export const CreateExercise = props => (
    <div className={'index-wrapper'}>
        <div className={'index-page'}>
            <div className="ig-form-heading">
                <h1 className="form-primary-title">EXERCISE CARD: DESIGN GREAT CONTENT</h1>
            </div>

            <CreateExerciseForm />
        </div>
    </div>
);
